module.exports = __webpack_public_path__ + "static/willow-41d6f80b7cbbfa84ebb8a3e11c7d6a3c.png";